"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.merchIdsContainGrowthSuite = exports.getAdditionalUnitsQuantityMinusIncluded = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _HubTypes = _interopRequireDefault(require("self-service-api/constants/HubTypes"));

var _getBaseProductForAdditionalUnitMerchId = function _getBaseProductForAdditionalUnitMerchId(merchandiseMap, additionalUnitMerchId) {
  return Object.keys(merchandiseMap).find(function (merchId) {
    return merchandiseMap[merchId].additionalUnitMerchId === additionalUnitMerchId;
  });
};

var getAdditionalUnitsQuantityMinusIncluded = function getAdditionalUnitsQuantityMinusIncluded(merchandiseMap, inputAdditionalUnitsQuantity, additionalUnitsMerchId) {
  var baseProductMerchId = _getBaseProductForAdditionalUnitMerchId(merchandiseMap, additionalUnitsMerchId);

  if (baseProductMerchId && merchandiseMap[baseProductMerchId].includedAdditionalUnits) {
    return inputAdditionalUnitsQuantity - merchandiseMap[baseProductMerchId].includedAdditionalUnits;
  }

  return inputAdditionalUnitsQuantity;
};

exports.getAdditionalUnitsQuantityMinusIncluded = getAdditionalUnitsQuantityMinusIncluded;

var merchIdsContainGrowthSuite = function merchIdsContainGrowthSuite(merchandiseMap, merchandiseIds) {
  var _foundEditions;

  var foundEditions = (_foundEditions = {}, (0, _defineProperty2.default)(_foundEditions, _HubTypes.default.MARKETING, null), (0, _defineProperty2.default)(_foundEditions, _HubTypes.default.SALES, null), (0, _defineProperty2.default)(_foundEditions, _HubTypes.default.SERVICE, null), _foundEditions);
  merchandiseIds.forEach(function (merchId) {
    var merch = merchandiseMap[merchId];

    if (merch.hubType in foundEditions && merch.edition) {
      foundEditions[merch.hubType] = merch.edition;
    }
  });
  var editionsAreSame = foundEditions[_HubTypes.default.MARKETING] !== null && foundEditions[_HubTypes.default.MARKETING] === foundEditions[_HubTypes.default.SALES] && foundEditions[_HubTypes.default.MARKETING] === foundEditions[_HubTypes.default.SERVICE];
  return editionsAreSame;
};

exports.merchIdsContainGrowthSuite = merchIdsContainGrowthSuite;